import { watch } from 'vue';
import { useToast } from '@/to-fsd/shared/hooks';
import { extractErrorMessage } from './utils';

const useToastError = (error, { duration = 4000 } = {}) => {
  const toast = useToast();

  watch(error, async error => {
    if (error) {
      toast.error({
        title: await extractErrorMessage(error),
        duration,
      });
    }
  });
};

export default useToastError;
